import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';
import { WorkgroupInformationModel } from 'src/app/models/workgroup-information.model';

/**
 * This API client is used to access the Identity API for the current logged in user and ITS organisation.
 */
@Injectable({
    providedIn: 'root'
})
export class IdentityMyApiClient {

    constructor(private http: HttpClient) { }

    /**
     * Get my assigned and public workgroups
     */
    GetMyWorkgroups(): Observable<WorkgroupInformationModel[]> {
        return this.http.get<WorkgroupInformationModel[]>(environment.identityUrl + "/api/my/workgroups");
    }
    /**
     * Get my assigned and public workgroups
     */
    GetOrganisationWorkgroups(): Observable<WorkgroupInformationModel[]> {
        return this.http.get<WorkgroupInformationModel[]>(environment.identityUrl + "/api/my/organisation/workgroups");
    }
}
